import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Box, Button, ButtonGroup} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useSelfCheckResponse} from 'data/queries/responses';

const useStyles = makeStyles(theme => ({
  button: {
    maxWidth: 300,
    margin: 'auto',
    '&:disabled': {
      color: 'rgba(0,0,0,0.8)',
    },
  },
  missed: {
    borderColor: theme.palette.primary.dark,
  },
  got: {
    borderColor: theme.palette.primary.light,
  },
}));

const SelfCheck = ({promptText}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(null);
  const [_, createResponse] = useSelfCheckResponse(promptText);
  const onSubmit = option => {
    setValue(option.text);
    createResponse(option.value);
  };
  const options = [
    {text: 'Got it', class: classes.got, value: true},
    {text: 'Missed it', class: classes.missed, value: false},
  ];

  return (
    <Box mt={2} mb={2}>
      <Box margin="auto" maxWidth={600}>
        <ButtonGroup fullWidth>
          {options.map(
            option =>
              (!value || value === option.text) && (
                <Button
                  key={option.text}
                  disabled={!!value}
                  onClick={() => onSubmit(option)}
                  className={clsx(option.class, classes.button)}
                >
                  {option.text}
                </Button>
              )
          )}
        </ButtonGroup>
      </Box>
    </Box>
  );
};

SelfCheck.propTypes = {
  promptText: PropTypes.string,
};

export default SelfCheck;
